/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import SpinnerLoader from '../../../../components/spinner-loader/spinner-loader.component';

import chargeWaitStyles from './charge-wait.styles';
import circleCheck from '../../../../assets/icons/circle_check.svg';
import { ITransaction } from '../../../../api/transactions/types';

type PropTypes = {
    guest?: ITransaction;
};

export const ChargeWait: FC<PropTypes> = ({ guest }) => {
    const intl = useIntl();

    const isStarting = guest?.transaction?.status !== 1;

    return (
        <div css={chargeWaitStyles.container}>
            <p css={[chargeWaitStyles.description, chargeWaitStyles.attempts]}>
                <img src={circleCheck} alt="circle-check" />
                {intl.formatMessage({ id: 'paymentSuccessWait' })}
            </p>
            {isStarting && (
                <>
                    <p css={chargeWaitStyles.description}>
                        {intl.formatMessage({ id: 'paymentSuccessWaitDescription' })}
                    </p>
                    <p css={[chargeWaitStyles.description, chargeWaitStyles.attempts]}>
                        {intl.formatMessage(
                            { id: 'paymentSuccessWaitAttempts' },
                            {
                                0: guest?.startAttempts || 1,
                            }
                        )}
                    </p>
                </>
            )}
            <div css={chargeWaitStyles.infoImageContainer}>
                <div css={chargeWaitStyles.infoImageContent}>
                    <SpinnerLoader />
                </div>
            </div>
        </div>
    );
};
